import { Reset as ResetIcon } from '@carbon/react/icons';
import { MultiSelect, SelectSkeleton } from '@carbon/react';
import { TooltipIcon } from 'components/tooltip-icon/tooltip-icon';
import { State } from 'types/api-responses';
import styles from './state-filter.module.scss';

const StateFilter = ({
  selectedStates,
  onChange,
  states,
  loading,
  error,
  onRefetch,
}: {
  selectedStates: string[];
  onChange: (abbreviations: string[]) => void;
  states: State[];
  loading: boolean;
  error: string | null;
  onRefetch?: () => void;
}) => {
  // Map selectedStates (abbreviations) to state objects
  const selectedStateAbbreviation = states.filter((s) =>
    selectedStates.includes(s.abbreviation)
  );

  return (
    <div className={styles.stateFilterWrapper}>
      {loading && <SelectSkeleton data-testid="state-filter-skeleton" />}
      {!loading && (
        <div className={styles.dropdownActionContainer}>
          <div className={styles.dropDown}>
            <MultiSelect
              id="state-multiselect"
              titleText=""
              items={states}
              itemToString={(item) => (item ? item.name : '')}
              onChange={({ selectedItems }) =>
                onChange((selectedItems ?? []).map((s) => s.abbreviation))
              }
              initialSelectedItems={selectedStateAbbreviation}
              label={error ? 'Error fetching states' : 'Select States'}
              invalid={!!error}
              disabled={!!error}
            />
            {error && onRefetch && (
              <div className={styles.refetchButton}>
                <TooltipIcon
                  data-testid="state-filter-refetch"
                  definition="Click to refetch the states"
                  onClick={onRefetch}
                >
                  <ResetIcon className={styles.resetIcon} />
                </TooltipIcon>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default StateFilter;
